import { useNavigate } from 'react-router-dom';

const baseBtnStyle = {
  padding: '16px 32px',
  fontSize: 18,
  color: '#fff',
  border: 'none',
  borderRadius: 10,
  cursor: 'pointer',
  transition: 'transform 0.15s, box-shadow 0.15s',
  fontWeight: 500
};

export default function AdminDashboard() {
  const navigate = useNavigate();
  
  // ✅ Subject buttons - all use the same route pattern
  const subjects = [
    { name: 'English', color: '#007BFF', rgb: '0,123,255' },
    { name: 'Math', color: '#28a745', rgb: '40,167,69' },
    { name: 'Science', color: '#6f42c1', rgb: '111,66,193' }
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login', { replace: true });
  };

  const handleHover = (e, isHovering, rgb) => {
    e.target.style.transform = isHovering ? 'translateY(-2px)' : 'translateY(0)';
    e.target.style.boxShadow = isHovering
      ? `0 6px 16px rgba(${rgb},0.3)`
      : `0 4px 12px rgba(${rgb},0.2)`;
  };

  return (
    <div style={{ textAlign: 'center', marginTop: 60, padding: '0 20px', maxWidth: 1200, margin: '60px auto' }}>
      <h1 style={{ marginBottom: 10 }}>Admin Dashboard</h1>
      <p style={{ marginBottom: 40, color: '#555', fontSize: 16 }}>Manage subjects, students, parents, exams, and assignments</p>

      {/* 🔹 Student Management Section */}
      <div style={{ marginBottom: 30 }}>
        <h3 style={{ marginBottom: 20, color: '#333', fontWeight: 600 }}>Student Management</h3>
        <div style={{ display: 'flex', gap: 15, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/admin/add-student')}
            style={{ ...baseBtnStyle, background: '#28a745', boxShadow: '0 4px 12px rgba(40,167,69,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '40,167,69')}
            onMouseOut={(e) => handleHover(e, false, '40,167,69')}
          >
            + Add Student
          </button>
          <button
            onClick={() => navigate('/admin/manage-student')}
            style={{ ...baseBtnStyle, background: '#17a2b8', boxShadow: '0 4px 12px rgba(23,162,184,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '23,162,184')}
            onMouseOut={(e) => handleHover(e, false, '23,162,184')}
          >
            Manage Students
          </button>
        </div>
      </div>

      {/* 🔹 Parent Management Section */}
      <div style={{ marginBottom: 30 }}>
        <h3 style={{ marginBottom: 20, color: '#333', fontWeight: 600 }}>Parent Management</h3>
        <div style={{ display: 'flex', gap: 15, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/admin/create-parent')}
            style={{ ...baseBtnStyle, background: '#28a745', boxShadow: '0 4px 12px rgba(40,167,69,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '40,167,69')}
            onMouseOut={(e) => handleHover(e, false, '40,167,69')}
          >
            + Add Parent
          </button>
          <button
            onClick={() => navigate('/admin/manage-parent')}
            style={{ ...baseBtnStyle, background: '#17a2b8', boxShadow: '0 4px 12px rgba(23,162,184,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '23,162,184')}
            onMouseOut={(e) => handleHover(e, false, '23,162,184')}
          >
            Manage Parents
          </button>
          <button
            onClick={() => navigate('/admin/assign-student-to-parent')}
            style={{ ...baseBtnStyle, background: '#fd7e14', boxShadow: '0 4px 12px rgba(253,126,20,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '253,126,20')}
            onMouseOut={(e) => handleHover(e, false, '253,126,20')}
          >
            Assign Student to Parent
          </button>
        </div>
      </div>

      {/* 🔹 Tutor Management Section - NEW */}
      <div style={{ marginBottom: 30 }}>
        <h3 style={{ marginBottom: 20, color: '#333', fontWeight: 600 }}>Tutor Management</h3>
        <div style={{ display: 'flex', gap: 15, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/admin/add-tutor')}
            style={{ ...baseBtnStyle, background: '#28a745', boxShadow: '0 4px 12px rgba(40,167,69,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '40,167,69')}
            onMouseOut={(e) => handleHover(e, false, '40,167,69')}
          >
            + Add Tutor
          </button>
          <button
            onClick={() => navigate('/admin/manage-tutor')}
            style={{ ...baseBtnStyle, background: '#17a2b8', boxShadow: '0 4px 12px rgba(23,162,184,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '23,162,184')}
            onMouseOut={(e) => handleHover(e, false, '23,162,184')}
          >
            Manage Tutors
          </button>
          <button
            onClick={() => navigate('/admin/assign-student-to-tutor')}
            style={{ ...baseBtnStyle, background: '#fd7e14', boxShadow: '0 4px 12px rgba(253,126,20,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '253,126,20')}
            onMouseOut={(e) => handleHover(e, false, '253,126,20')}
          >
            Assign Student to Tutor
          </button>
        </div>
      </div>

      {/* 🔹 Exam Builder - Branching Section */}
      <div style={{ marginBottom: 30 }}>
        <h3 style={{ marginBottom: 20, color: '#333', fontWeight: 600 }}>Exam Builder - Branching</h3>
        <div style={{ display: 'flex', gap: 15, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/admin/exam-builder')}
            style={{ ...baseBtnStyle, background: '#6f42c1', boxShadow: '0 4px 12px rgba(111,66,193,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '111,66,193')}
            onMouseOut={(e) => handleHover(e, false, '111,66,193')}
          >
            Exam Branch Builder
          </button>
          <button
            onClick={() => navigate('/admin/view-exams')}
            style={{ ...baseBtnStyle, background: '#fd7e14', boxShadow: '0 4px 12px rgba(253,126,20,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '253,126,20')}
            onMouseOut={(e) => handleHover(e, false, '253,126,20')}
          >
            View Branching Exams
          </button>
        </div>
      </div>

      {/* 🔹 English Exam Builder - Flow Section */}
      <div style={{ marginBottom: 30 }}>
        <h3 style={{ marginBottom: 20, color: '#333', fontWeight: 600 }}>English Exam Builder - Flow</h3>
        <div style={{ display: 'flex', gap: 15, justifyContent: 'center', flexWrap: 'wrap' }}>          
          <button
            onClick={() => navigate('/admin/flow-builder')}
            style={{ ...baseBtnStyle, background: '#6610f2' }}
            onMouseOver={(e) => handleHover(e, true, '102,16,242')}
            onMouseOut={(e) => handleHover(e, false, '102,16,242')}
          >
            Exam Flow Builder
          </button>
          <button
            onClick={() => navigate('/admin/flow-builder-exams')}
            style={{ ...baseBtnStyle, background: '#6610f2', boxShadow: '0 4px 12px rgba(102,16,242,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '102,16,242')}
            onMouseOut={(e) => handleHover(e, false, '102,16,242')}
          >
            View Flow Exams
          </button>
        </div>
      </div>

      {/* 🔹 Math Exam Builder - Flow Section */}
      <div style={{ marginBottom: 30 }}>
        <h3 style={{ marginBottom: 20, color: '#333', fontWeight: 600 }}>Math Exam Builder - Flow</h3>
        <div style={{ display: 'flex', gap: 15, justifyContent: 'center', flexWrap: 'wrap' }}>          
          <button
            onClick={() => navigate('/admin/math-flow-builder')}
            style={{ ...baseBtnStyle, background: '#6610f2' }} 
            onMouseOver={(e) => handleHover(e, true, '102,16,242')}
            onMouseOut={(e) => handleHover(e, false, '102,16,242')}
          >
            Math Exam Flow Builder
          </button>
          
          <button
            onClick={() => navigate('/admin/math-flow-builder-exams')}
            style={{ ...baseBtnStyle, background: '#6610f2', boxShadow: '0 4px 12px rgba(102,16,242,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '102,16,242')}
            onMouseOut={(e) => handleHover(e, false, '102,16,242')}
          >
            View Math Exams
          </button>
        </div>
      </div>

      {/* 🔹 Science Exam Builder - Flow Section */}
      <div style={{ marginBottom: 30 }}>
        <h3 style={{ marginBottom: 20, color: '#333', fontWeight: 600 }}>Science Exam Builder - Flow</h3>
        <div style={{ display: 'flex', gap: 15, justifyContent: 'center', flexWrap: 'wrap' }}>          
          <button
            onClick={() => navigate('/admin/science-flow-builder')}
            style={{ ...baseBtnStyle, background: '#6610f2' }} 
            onMouseOver={(e) => handleHover(e, true, '102,16,242')}
            onMouseOut={(e) => handleHover(e, false, '102,16,242')}
          >
            Science Exam Flow Builder
          </button>
          <button
            onClick={() => navigate('/admin/science-flow-builder-exams')}
            style={{ ...baseBtnStyle, background: '#6610f2', boxShadow: '0 4px 12px rgba(102,16,242,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '102,16,242')}
            onMouseOut={(e) => handleHover(e, false, '102,16,242')}
          >
            View Science Exams
          </button>
        </div>
      </div>

      {/* 🔹 Assign Exam and Review Results Section */}
      <div style={{ marginBottom: 30 }}>
        <h3 style={{ marginBottom: 20, color: '#333', fontWeight: 600 }}>Assign Exam and Review Results</h3>
        <div style={{ display: 'flex', gap: 15, justifyContent: 'center', flexWrap: 'wrap' }}>         
          <button
            onClick={() => navigate('/admin/assign-exam')}
            style={{ ...baseBtnStyle, background: '#e83e8c', boxShadow: '0 4px 12px rgba(232,62,140,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '232,62,140')}
            onMouseOut={(e) => handleHover(e, false, '232,62,140')}
          >
            📤 Assign Exams
          </button>
          <button
            onClick={() => navigate('/admin/review-exams')}
            style={{ ...baseBtnStyle, background: '#6610f2', boxShadow: '0 4px 12px rgba(102,16,242,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '102,16,242')}
            onMouseOut={(e) => handleHover(e, false, '102,16,242')}
          >
            📊 Review Results
          </button>
        </div>
      </div>

      {/* 🔹 Subject Question Management Section */}
      <div style={{ marginBottom: 40 }}>
        <h3 style={{ marginBottom: 20, color: '#333', fontWeight: 600 }}>Manage Subject Questions</h3>
        <div style={{ display: 'flex', gap: 15, justifyContent: 'center', flexWrap: 'wrap' }}>
          {subjects.map(sub => (
            <button
              key={sub.name}
              onClick={() => navigate(`/admin/questions/${sub.name.toLowerCase()}`)}
              style={{ 
                ...baseBtnStyle, 
                background: sub.color, 
                boxShadow: `0 4px 12px rgba(${sub.rgb},0.2)`,
                minWidth: 140
              }}
              onMouseOver={(e) => handleHover(e, true, sub.rgb)}
              onMouseOut={(e) => handleHover(e, false, sub.rgb)}
            >
              View {sub.name} Exam Questions
            </button>
          ))}
        </div>
      </div>

      {/* 🔹 Upload Subject Questions Section */}
      <div style={{ marginBottom: 40 }}>
        <h3 style={{ marginBottom: 20, color: '#333', fontWeight: 600 }}>Upload Subject Questions</h3>
        <div style={{ display: 'flex', gap: 15, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/admin/upload-english')}
            style={{ ...baseBtnStyle, background: '#fd7e14', boxShadow: '0 4px 12px rgba(253,126,20,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '253,126,20')}
            onMouseOut={(e) => handleHover(e, false, '253,126,20')}
          >
            Upload English Questions
          </button>
          <button
            onClick={() => navigate('/admin/upload-math')}
            style={{ ...baseBtnStyle, background: '#fd7e14', boxShadow: '0 4px 12px rgba(253,126,20,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '253,126,20')}
            onMouseOut={(e) => handleHover(e, false, '253,126,20')}
          >
            Upload Math Questions
          </button>
          <button
            onClick={() => navigate('/admin/upload-science')}
            style={{ ...baseBtnStyle, background: '#fd7e14', boxShadow: '0 4px 12px rgba(253,126,20,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '253,126,20')}
            onMouseOut={(e) => handleHover(e, false, '253,126,20')}
          >
            Upload Science Questions
          </button>
        </div>
      </div>

      {/* ✅ NEW: Manage Tag Definitions Section */}
      <div style={{ marginBottom: 40 }}>
        <h3 style={{ marginBottom: 20, color: '#333', fontWeight: 600 }}>Manage Tag Definitions</h3>
        <div style={{ display: 'flex', gap: 15, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/admin/manage-tags')}
            style={{ ...baseBtnStyle, background: '#20c997', boxShadow: '0 4px 12px rgba(32,201,151,0.2)' }}
            onMouseOver={(e) => handleHover(e, true, '32,201,151')}
            onMouseOut={(e) => handleHover(e, false, '32,201,151')}
          >
            🏷️ Manage Tag Meanings
          </button>
        </div>
      </div>

      {/*  Logout Section */}
      <div style={{ borderTop: '1px solid #eee', paddingTop: 30 }}>
        <button
          onClick={handleLogout}
          style={{ 
            ...baseBtnStyle, 
            background: '#dc3545', 
            boxShadow: '0 4px 12px rgba(220,53,69,0.2)',
            padding: '12px 40px'
          }}
          onMouseOver={(e) => handleHover(e, true, '220,53,69')}
          onMouseOut={(e) => handleHover(e, false, '220,53,69')}
        >
          🔐 Logout
        </button>
      </div>
    </div>
  );
}